import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"height":"calc(100vh)","overflow":"hidden"} }
const _hoisted_2 = { style: {"display":"flex","height":"100%","align-items":"center"} }
const _hoisted_3 = { style: {"text-align":"right","width":"50%","display":"flex","justify-content":"right","cursor":"pointer"} }
const _hoisted_4 = { style: {"display":"flex","margin-top":"-1px"} }
const _hoisted_5 = { style: {"padding-left":"5px","padding-top":"3px"} }
const _hoisted_6 = { style: {"margin-top":"-5px","margin-left":"5px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_systemAlert = _resolveComponent("systemAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_container, { style: {"height":"100%","overflow":"hidden"} }, {
        default: _withCtx(() => [
          _createVNode(_component_el_aside, { width: "auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu, {
                "default-active": _ctx.defaultActive,
                class: "el-menu-vertical-demo",
                "background-color": "#545c64",
                "text-color": "#fff",
                "active-text-color": "#ffd04b",
                style: {"height":"100%"},
                router: ""
              }, {
                default: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "el-menu-box" }, [
                    _createElementVNode("div", {
                      class: "logo-image",
                      style: {"width":"18px","height":"18px","background-size":"18px 18px"}
                    }),
                    _createElementVNode("div", { style: {"padding-left":"5px","padding-top":"7px"} }, " OverallAuth2.0 ")
                  ], -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (menuItem) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: menuItem.path
                    }, [
                      (menuItem.children && menuItem.children.length)
                        ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                            index: menuItem.path,
                            key: menuItem.name
                          }, {
                            title: _withCtx(() => [
                              _createVNode(_component_el_icon, { size: "14" }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(menuItem.menuIcon), { class: "icons" }))
                                ]),
                                _: 2
                              }, 1024),
                              _createTextVNode(_toDisplayString(menuItem.name), 1)
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.children, (subMenuItem) => {
                                return (_openBlock(), _createBlock(_component_el_menu_item, {
                                  index: subMenuItem.path,
                                  route: { name: subMenuItem.name },
                                  key: subMenuItem.name,
                                  onClick: ($event: any) => (_ctx.menuItemClick(subMenuItem)),
                                  style: {"cursor":"pointer"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, { size: "14" }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createBlock(_resolveDynamicComponent(subMenuItem.menuIcon), { class: "icons" }))
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createTextVNode(" " + _toDisplayString(subMenuItem.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["index", "route", "onClick"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["index"]))
                        : (_openBlock(), _createBlock(_component_el_menu_item, {
                            index: menuItem.path,
                            key: menuItem.path,
                            route: { name: menuItem.name },
                            onClick: ($event: any) => (_ctx.menuItemClick(menuItem)),
                            style: {"cursor":"pointer"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(menuItem.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["index", "route", "onClick"]))
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["default-active"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_container, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_header, { class: "headerCss" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { style: {"text-align":"left","width":"50%","font-size":"18px","display":"flex"} }, [
                      _createElementVNode("div", {
                        class: "logo-image",
                        style: {"width":"32px","height":"32px"}
                      }),
                      _createElementVNode("div", { style: {"padding-left":"10px","padding-top":"7px"} }, " OverallAuth2.0 统一权限分发中心 ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_el_icon, {
                          onClick: _ctx.heperClick,
                          style: {"cursor":"pointer"},
                          size: "25",
                          color: "blue"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_QuestionFilled)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_el_button, {
                          type: "text",
                          onClick: _ctx.heperClick,
                          style: {"margin-left":"5px","margin-right":"10px","margin-top":"-2px"}
                        }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode("帮助中心")
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _cache[5] || (_cache[5] = _createElementVNode("div", {
                        class: "user-image",
                        style: {"width":"22px","height":"22px","background-size":"22px 22px"}
                      }, null, -1)),
                      _createElementVNode("div", _hoisted_5, " 欢迎：" + _toDisplayString(_ctx.userStore.userInfo.userName), 1),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_el_button, {
                          type: "text",
                          onClick: _ctx.logoutClick
                        }, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createTextVNode("退出登录")
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_main, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_affix, { offset: 60 }, {
                    default: _withCtx(() => [
                      (_ctx.tabsList.length > 0 && _ctx.tabsList.length !== undefined)
                        ? (_openBlock(), _createBlock(_component_el_tabs, {
                            key: 0,
                            modelValue: _ctx.defaultActive,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.defaultActive) = $event)),
                            class: "demo-tabs",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tabsClick(_ctx.defaultActive))),
                            onTabRemove: _ctx.tabRemoveClick
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabsList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                                  label: item?.name,
                                  name: item?.path,
                                  key: item?.path,
                                  closable: item?.path == '/panel' ? false : true,
                                  style: {"font-size":"16px"}
                                }, null, 8, ["label", "name", "closable"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onTabRemove"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_view)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_systemAlert, { isVisibles: _ctx.isAlertVisibles }, null, 8, ["isVisibles"])
  ], 64))
}